import BaseGrid from 'components/atoms/base-grid';
import SmsCampaignsDashboardHeader from 'components/organisms/sms-campaigns/dashboard-header';
import {
  CAMPAIGNS_PER_PAGE,
  useGetCampaigns,
  useSmsCampaignsQueryFilter,
} from 'infrastructure/hooks/sms-campaigns';
import SmsCampaignDashboardItem from 'components/organisms/sms-campaigns/dashboard-item';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import BasePagination from 'components/atoms/base-pagination';
import { type FC, useReducer } from 'react';
import AddEditCampaignForm from 'components/organisms/sms-campaigns/campaigns/add-edit-campaign-form';

import s from './styles.module.scss';

interface SmsCampaignDashboardProps {}

const SmsCampaignDashboard: FC<SmsCampaignDashboardProps> = () => {
  const { filter } = useSmsCampaignsQueryFilter();
  const { data, isLoading, isFetching } = useGetCampaigns(filter);
  const [open, toggleOpen] = useReducer((v) => !v, false);

  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <SmsCampaignsDashboardHeader handleAddCampaign={toggleOpen} />
      <BaseSpinWrapper spinning={isLoading || isFetching}>
        <div className={s['campaign-items-wrapper']}>
          {data?.items?.map((item, index) => {
            return <SmsCampaignDashboardItem {...item} key={index} />;
          })}
        </div>
      </BaseSpinWrapper>
      <BasePagination
        total={data?.count}
        page={filter.page}
        align="center"
        pageSize={CAMPAIGNS_PER_PAGE}
        hide
      />
      {open && <AddEditCampaignForm open={open} toggleOpen={toggleOpen} />}
    </BaseGrid>
  );
};
export default SmsCampaignDashboard;
